import { Component, forwardRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, FormBuilder } from '@angular/forms';
import { PrFormListItemComponent } from '@app/components/pr-form/pr-form-list-item/pr-form-list-item.component';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { combineLatest, Subject } from 'rxjs';
import { EaFeesFormService } from './ea-fees-form.service';

@Component({
    selector: 'ea-fees-form',
    templateUrl: './ea-fees-form.component.html',
    styleUrls: ['./ea-fees-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaFeesFormComponent),
        },
    ],
    standalone: false
})
export class EaFeesFormComponent extends PrFormAbstract implements OnInit {
  /* connaissances = [
    { id: 'netMensuel', label: 'Net mensuel', suffix: '€/mois' },
    { id: 'netAnnuel', label: 'Net annuel', suffix: '€/an' },
    { id: 'brutMensuel', label: 'Brut mensuel', suffix: '€/mois' },
    { id: 'brutAnnuel', label: 'Brut annuel', suffix: '€/an' }
  ]; */

  @ViewChild(PrFormListItemComponent) formListITem: PrFormListItemComponent;

  estateTypes = [];
  periodicityTypes = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    public eaFeesFormService: EaFeesFormService,
    protected refDao: ReferenceDao,
  ) {
    super(formConstructor);
    this.eaFeesFormService.generateSubject.subscribe(
      formGroup => (this.form = formGroup),
    );
  }

  ngOnInit() {
    if (!this.form.controls) this.initForm(this.entity);
    combineLatest([
      this.refDao.getEstateType(),
      this.refDao.getPeriodicityType(),
    ]).subscribe(([estateTypes, periodicityTypes]) => {
      this.estateTypes = estateTypes;
      this.periodicityTypes = periodicityTypes;
    });
  }

  onDelete(index) {
    this.eaFeesFormService.removeFee(
      index,
      this.fees,
      this.entity.userId,
      this.entity.typeUrl,
      this.entity.id,
    );
    this.entity.expenses.splice(index, 1);
  }

  get fees(): UntypedFormArray {
    return this.form.get('fees') as UntypedFormArray;
  }

  validate(fee) {
    // this.formListITem.close()
    // this.form
  }

  public generate(): any {
    return this.eaFeesFormService.generate(this.entity);
  }

  public extract() {
    return this.eaFeesFormService.extract(this.form);
  }

  onSubmit() {}

  getFeesType(value: string) {
    if (this.estateTypes.length > 0) {
      let type = this.estateTypes.find(item => item.id === value);
      return type.value;
    } else return null;
  }
  getPeriodicityType(value: string) {
    if (this.periodicityTypes.length > 0) {
      let type = this.periodicityTypes.find(item => item.id === value);
      return type.value;
    } else return null;
  }

  doneSubject = new Subject<void>();
}
